import React from "react";

import { Api } from "../../../../../../common/openapi";

export const LogSeverityDescription: React.FC<{ severity: Api.LogSeverity }> = ({ severity }) => {
	switch (severity) {
		case Api.LogSeverity.ERROR:
			return (
				<>
					Severity level: <span className="font-bold">errors</span> (alert, err, error, crit, critical, fatal, severe,
					emerg or emergency)
				</>
			);
		case Api.LogSeverity.WARNING:
			return (
				<>
					Severity level: <span className="font-bold">warnings</span> (warning or warn)
				</>
			);
		case Api.LogSeverity.OTHER:
			return (
				<>
					Severity level: <span className="font-bold">other</span> (trace, debug, info, notice or unknown)
				</>
			);
	}

	return null;
};
